<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="status" slot-scope="scope">
        <el-tag :class="'client-status-class-' + scope.row.status"
        >{{ getstatus(scope.row.status) }}
        </el-tag>
      </template>

      <template slot="menuLeft">
        <!--<el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.carmonthchargerule_delete"
          @click="handleDelete"
          >删 除
        </el-button>-->
        <el-button
          type="primary"
          size="small"
          icon="el-icon-top"
          v-if="false"
          plain
          @click="monthCarChargeRuleSync"
          >收费规则同步
        </el-button>
      </template>

     <!-- <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-remove-outline"
          @click="disable(scope.row)"
          style="color: #ff0000"
        >停用
        </el-button>
      </template>-->

    </avue-crud>
  </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update,disable } from '@/api/v4ward/car/carmonthchargerule';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        sarchShow: true,
        searchMenuSpan: 12,
        calcHeight: 100,
        tip: false,
        indexLabel: '序号',
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        dialogWidth: '40%',
        // refreshBtn:false,
        column: [
          {
            label: '车场名称',
            type: 'tree',
            prop: 'spaceId',
            labelWidth: 120,
            search: true,
            editDisplay: false,
            viewDisplay: false,
            cell: true,
            props: {
              label: 'title',
              value: 'key',
            },
            rules: [
              {
                required: true,
                message: '请输入车场名称',
              },
            ],
            dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
            change: ({ value, column }) => {
              this.generateRemark();
            },
          },
          {
            label: '套餐名称',
            labelWidth: 120,
            prop: 'setmealName',
            maxlength: 10,
            span: 24,
            rules: [
              {
                required: true,
                message: '请输入套餐名称',
              },
            ],
          },
          /*{
            label: '套餐类型',
            type: 'select',
            labelWidth: 120,
            dicUrl: '/api/blade-system/dict/dictionary?code=car_month_package',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            prop: 'packageType',
            search: true,
            rules: [
              {
                required: true,
                message: '请输入套餐类型',
              },
            ],
          },*/
          {
            label: '车辆类型',
            type: 'select',
            labelWidth: 120,
            dicUrl: '/api/blade-system/dict/dictionary?code=car_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            prop: 'costSort',
            search: true,
            rules: [
              {
                required: true,
                message: '请输入车辆类型',
              },
            ],
            change: ({ value, column }) => {
              this.generateRemark();
            },
          },
          {
            label: '减免金额(元)',
            prop: 'cutMoney',
            labelWidth: 120,
            align: 'right',
            headerAlign: 'right',
            type: 'number',
            value: 0.0,
            hide: true,
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
          },
          {
            label: '单价(元)',
            prop: 'costPrice',
            labelWidth: 120,
            headerAlign: 'right',
            align: 'right',
            type: 'number',
            editDisabled: true,
            precision: 2,
            mock: {
              type: 'number',
              max: 1,
              min: 2,
              precision: 2,
            },
            minRows: 0.01,
            rules: [
              {
                required: true,
                message: '请输入单价',
                trigger: 'blur',
              },
              {
                type: 'number',
                min: 0.01,
                max: 9999,
                message: '单价超过9999',
                trigger: 'blur'
              }
            ],
            change: ({ value, column }) => {
              this.generateRemark();
            },
          },
          /*{
            label: '应用到APP',
            prop: 'appFlag',
            hide: true,
            display: false,
            labelWidth: 120,
            type: 'switch',
            dicUrl: '/api/blade-system/dict/dictionary?code=yes_no',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            rules: [
              {
                required: true,
                message: '请输入套餐类型是否应用到APP(套餐)',
              },
            ],
          },*/
          {
            label: '套餐说明',
            prop: 'remark',
            labelWidth: 120,
            type: 'textarea',
            minRows: 2,
            maxlength: 20,
            overHidden: true,
            span: 24,
            rules: [
              {
                required: true,
                message: '请输入套餐说明',
                trigger: 'blur',
              },
            ],
            // addDisplay: false,
            // editDisplay: false,
          },

          /*{
            label: '状态',
            prop: 'status',
            display: false,
            search: false,
            type: 'select',
            width: 80,
            hide: false,
            slot: true,
            editDisabled: true,
            addDisabled: true,
          },*/
        ],
      },
      data: [],
    };
  },
  watch: {

    /*'form.costPrice'(){
      const column = this.findObject(this.option.column, 'costPrice');
      if(this.form.status == 0){
        column.editDisabled=true;
      }else{
        column.editDisabled=false;
      }
    },
    'form.setmealName'(){
      const column = this.findObject(this.option.column, 'setmealName');
      if(this.form.status == 0){
        column.editDisabled=true;
      }else{
        column.editDisabled=false;
      }
    },
    'form.costSort'(){
      const column = this.findObject(this.option.column, 'costSort');
      if(this.form.status == 0){
        column.editDisabled=true;
      }else{
        column.editDisabled=false;
      }
    },
    'form.remark'(){
      const column = this.findObject(this.option.column, 'remark');
      if(this.form.status == 0){
        column.editDisabled=true;
      }else{
        column.editDisabled=false;
      }
    },*/
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.carmonthchargerule_add, false),
        viewBtn: this.vaildData(this.permission.carmonthchargerule_view, false),
        delBtn: this.vaildData(this.permission.carmonthchargerule_delete, false),
        editBtn: this.vaildData(this.permission.carmonthchargerule_edit, false),
        syncBtn: this.vaildData(this.permission.carmonthchargerule_sync, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    generateRemark() {
      setTimeout(() => {
        let costSortStr = this.form.$costSort;
        let spaceIdStr = this.form.$spaceId;
        let costPrice = this.form.costPrice;
        if (this.vdui.isNotEmpty(costPrice)) {
          this.form.remark = spaceIdStr + costSortStr + '  ' + costPrice + '元';
        }
      }, 0);
    },
    monthCarChargeRuleSync() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定同步月卡车收费规则到停车场?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return syncMonthCarChargeRules({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {

      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    disable(row) {
      if (row.status == 0) {
        this.$message.warning(' 该条月卡车收费规制已停用！');
        return;
      }
      this.$confirm('是否选择停用套餐', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return disable({ id: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
    getstatus(status) {
      if (status === 1) {
        return '启动';
      } else if (status === 0) {
        return '停用';
      } else {
        return '其他';
      }
    },
  },
};
</script>


<style lang="scss" scoped>
::v-deep .avue-form__menu--center {
    text-align: right;
}
</style>
